angular.module("app.modalControllers").controller("ConfirmDeleteGameModalController", [
    '$scope',
    '$uibModalInstance',
    'gameName',
    function ($scope, $modalInstance, gameName) {
        $scope.gameName = gameName;

        $scope.ok = function () {
            $modalInstance.close();
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    }
]);
